import React from 'react';
import styles from './StorySection.module.scss';

export const StoryItem = ({ number, title, description }) => {
  return (
    <div className={styles.storyItem}>
      <div className={styles.storyHeader}>
        <div className={styles.storyContent}>
          <div className={styles.storyNumber}>{number}</div>
          <div className={styles.storyTitle}>{title}</div>
        </div>
      </div>
      <div className={styles.storyDescription}>{description}</div>
    </div>
  );
};